import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'EVO',
    name: 'Clouded Mesmer',
    id: 'CloudedMesmer',
    health: 60,
    difficulty: 7,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
